/* BB 2026 — motion layer.
   Two effects, both transform/opacity only so they stay off the main thread:
     · reveal    elements ease in the first time they enter the viewport
     · parallax  images drift inside their card as the page scrolls
   Everything is opt-out under prefers-reduced-motion, and every element is
   left in its final state if this script never runs. */
(function () {
  if (window.__bbMotionReady) return;
  window.__bbMotionReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  /* ---------- reveal on scroll ---------- */
  var REVEAL = [
    '.bb-hero__copy > *',
    '.bb-hero__media',
    '.bb-assure__item',
    '.bb-rail__head',
    '.bb-cat__card',
    '.bb-viz__panel',
    '.bb-proof__in > *',
    '.bb-pills__list li',
    '.bb-feat__media',
    '.bb-feat__copy > *',
    '.bb-band__box',
    '.bb-sign__in > *',
    // Trade page. Both are real grids, so the sibling stagger already in
    // markReveals gives each row a 70ms cascade for free.
    '.bb-vgrid__card',
    '.bb-steps__step',
    // About. The whole chapter is the unit, not its halves: revealing figure
    // and text separately would race the two columns of the same row.
    // (.bb-ach__pair exists on one chapter only, so it is the wrong handle.)
    '.bb-aopen__in > *',
    '.bb-aopen__fact',
    '.bb-ach__ch'
  ].join(',');

  // Marked only after load, and only below the fold. Before `load` the images
  // have no height, the document collapses to roughly one viewport, and every
  // element looks on-screen — which is how an earlier version revealed the
  // whole page at once. Not marking what is already visible also means it can
  // never blink out and fade back in.
  function markReveals(root) {
    if (!settled) return;
    var vh = window.innerHeight;
    (root || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.dataset.bbReveal !== undefined) return;
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;   // hidden panel: leave alone
      if (r.top < vh * 0.88) return;                  // on screen: no animation
      el.dataset.bbReveal = '';
      var sibs = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--bb-reveal-delay', Math.min(sibs, 6) * 70 + 'ms');
    });
  }

  function revealAllPending() {
    document.querySelectorAll('[data-bb-reveal=""]').forEach(function (el) {
      el.dataset.bbReveal = 'in';
    });
  }

  // Reveal is driven by the same scroll loop as the parallax rather than an
  // IntersectionObserver: one source of truth for geometry, and no dependency
  // on when the observer chooses to deliver its first callback. An element in
  // a hidden panel, or one that is somehow never reached, is revealed rather
  // than left invisible — a decoration must never cost anyone the content.
  function sweep() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-bb-reveal=""]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if ((r.width === 0 && r.height === 0) || r.top < vh * 0.88) el.dataset.bbReveal = 'in';
    });
  }

  /* ---------- parallax inside cards ---------- */
  var PARALLAX = [
    '.bb-cat__img',
    '.bb-feat__img',
    '.bb-hero__img',
    '.bb-modal__mat-img',
    // Pipeline's own image frames, so editorial pages drift like the homepage.
    '.tile__image img',
    '.gallery__item__wrapper img',
    '.image__hero__scale img',
    '.standard__image img'
  ].join(',');
  // The trade band's photograph is a background, not an <img>, so it drifts by
  // background-position instead of transform.
  var BG_PARALLAX = '.bb-band__box';
  var items = [];
  var bgItems = [];

  function collectParallax(root) {
    (root || document).querySelectorAll(PARALLAX).forEach(function (el) {
      if (el.dataset.bbParallax || el.closest('.bb-modal')) return;
      // Frames the theme already animates are left alone: a transform here
      // would out-rank their hover zoom and fight its two-second transition.
      if (el.closest('.has-zoom-animation')) return;
      if (/bb_logo/i.test(el.getAttribute('src') || '')) return;
      // The drift only reads as depth if the frame crops it. An image whose
      // frame lets it spill would just slide against the page.
      var frame = el.parentElement;
      if (frame && getComputedStyle(frame).overflow === 'visible' &&
          !el.closest('.bb-cat__card')) return;
      el.dataset.bbParallax = '1';
      items.push(el);
    });
    (root || document).querySelectorAll(BG_PARALLAX).forEach(function (el) {
      if (el.dataset.bbParallax) return;
      if (getComputedStyle(el).backgroundImage === 'none') return;
      el.dataset.bbParallax = '1';
      bgItems.push(el);
    });
  }

  var settled = document.readyState === 'complete';
  window.addEventListener('load', function () {
    settled = true;
    markReveals();
    setTimeout(sweep, 200);
  });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) continue;
        // -1 when the element is entering, +1 when it is leaving.
        var progress = ((r.top + r.height / 2) - vh / 2) / (vh / 2);
        if (progress < -1) progress = -1;
        if (progress > 1) progress = 1;
        el.style.setProperty('--bb-shift', (progress * -14).toFixed(2) + 'px');
      }
      for (var j = 0; j < bgItems.length; j++) {
        var bg = bgItems[j];
        var br = bg.getBoundingClientRect();
        if (br.bottom < -80 || br.top > vh + 80) continue;
        var bp = ((br.top + br.height / 2) - vh / 2) / (vh / 2);
        if (bp < -1) bp = -1;
        if (bp > 1) bp = 1;
        bg.style.setProperty('--bb-bg-pos', (50 + bp * 6).toFixed(1) + '%');
      }
      // Only sweep once the page has finished loading and its real height is
      // known; before that a sweep would make the same mistake.
      if (settled) sweep();
      ticking = false;
    });
  }

  function init(root) {
    collectParallax(root);
    onScroll();
    if (settled) markReveals(root);
  }

  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // Tab panels and accordions reveal their contents the moment they are shown.
  document.addEventListener('click', function () { setTimeout(sweep, 60); }, true);
  // Last resort so nothing can ever be stranded invisible. Long enough that a
  // slow page still gets to animate — six seconds was pre-empting the effect
  // on this homepage, which takes ~7s to settle with all its imagery.
  setTimeout(revealAllPending, 15000);
})();
